//@ts-nocheck
import React from "react";
import { useSkipPayruns } from "@xemplo/payrun-query";
import { withRouter } from "../../../../hooks";

export const withSkipPayrunsHook = (Component: typeof React.Component) => {
  function ComponentWithProp(props: any) {
    const { mutateAsync: skipPayrunMutation } = useSkipPayruns();
    return <Component skipPayrunMutation={skipPayrunMutation} {...props} />;
  }

  return withRouter(ComponentWithProp);
};
